<template>
  <div class="sc-object-card__tracks-controller">
    <div class="sc-object-card__tracks-controller__row">
      <el-button
        class="r-button"
        size="mini"
        :type="!trackLayerId ? `success` : `danger`"
        :loading="isLoading"
        @click="clickHandler"
        :disabled="isDisabled"
      >
        {{ !trackLayerId ? $t("show-track") : $t("hide-track") }}
      </el-button>
    </div>
    <transition name="component-fade" mode="out-in">
      <div class="sc-object-card__tracks-controller__panel" v-if="trackLayerId">
        <div class="sc-object-card__tracks-controller__row">
          <r-text type="caption">
            {{ $t("sc:track-period") }}
          </r-text>
        </div>
        <div class="sc-object-card__tracks-controller__row">
          <r-text>{{ $t("from") }}</r-text>
          <el-date-picker
            class="r-date-picker"
            size="mini"
            v-model="timeFrom"
            format="dd.MM.yyyy HH:mm"
            type="datetime"
            align="right"
            placeholder="Выберите начало"
            :picker-options="pickerOptions"
          />
        </div>
        <div class="sc-object-card__tracks-controller__row">
          <r-text>{{ $t("to") }}</r-text>
          <el-date-picker
            class="r-date-picker"
            size="mini"
            v-model="timeTo"
            format="dd.MM.yyyy HH:mm"
            type="datetime"
            align="right"
            placeholder="Выберите дату и время"
            :picker-options="pickerOptions"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { notifyFactory } from "@/utils";
import moment from "moment";

export default {
  props: {
    trackUrl: {
      type: String,
      required: true,
      default: ""
    },
    id: {
      type: String,
      required: true,
      default: ""
    },
    uid: {
      type: String,
      default: null
    },
    layer_id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isLoading: false,
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < Date.now() - 500000000
          );
        }
      },
      timeFrom: moment(new Date())
        .subtract(2, "hour")
        .format(),
      timeTo: moment(new Date()).format()
    };
  },
  watch: {
    timeFrom() {
      this.createTrack();
    },
    timeTo() {
      this.createTrack();
    }
  },
  computed: {
    isDisabled() {
      return !this.timeFrom || !this.timeTo;
    },
    trackLayer() {
      return this.$store.state.situationCenter.trackLayer;
    },
    trackLayerId() {
      return this.$store.state.situationCenter.trackLayer.layer_id;
    }
  },
  methods: {
    clickHandler() {
      if (this.trackLayerId) this.clearTrack();
      else this.createTrack();
    },
    async createTrack() {
      this.isLoading = true;

      try {
        const url =
          this.layer_id === "TagilPublicTransport?format=vehicles"
            ? `${this.trackUrl}&id=${this.uid ||
                this.id.split("?id:")[1]}${this.getTimeConfig()}`
            : `track/${this.trackUrl}?id=${this.uid ||
                this.id.split("?id:")[1]}${this.getTimeConfig()}`;
        const { data } = await this.$store.dispatch("REQUEST", {
          url
        });

        if (!data) {
          const title = this.$t("request:null:title");
          const message = this.$t("request:null:message");
          this.$notify(notifyFactory("warning", title, message));
          this.isLoading = false;

          this.$store.commit("SET_SI_CENTER_TRACK_LAYER", {
            layer_id: this.layer_id,
            data: []
          });

          return;
        }

        if (this.layer_id !== "TagilPublicTransport?format=vehicles") {
          this.$store.commit("SET_SI_CENTER_TRACK_LAYER", {
            layer_id: this.layer_id,
            data: data.map(e => {
              e.avg_speed = Math.round(e.avg_speed);
              e.distance = (e.distance / 1000).toFixed(2);
              e.from_time = moment(e.from_time).format("DD.MM.YY HH:mm");
              e.to_time = moment(e.to_time).format("DD.MM.YY HH:mm");
              return e;
            })
          });
        } else {
          this.$store.commit("SET_SI_CENTER_TRACK_LAYER", {
            layer_id: this.layer_id,
            data: {
              geom: data
            }
          });
        }

        this.isLoading = false;
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
    clearTrack() {
      this.$store.commit("SET_SI_CENTER_TRACK_LAYER", {
        layer_id: null,
        data: null
      });
    },
    getTimeConfig() {
      return `&from=${encodeURIComponent(
        moment(this.timeFrom).format()
      )}&to=${encodeURIComponent(moment(this.timeTo).format())}`;
    }
  }
};
</script>

<style lang="scss">
.sc-object-card__tracks-controller {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  max-height: 460px;
  overflow: hidden;
  overflow-y: auto;
  &__panel {
    width: 100%;
    margin-bottom: 16px;
  }
  &__row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-date-editor {
      width: 220px !important;
    }
    .r-button {
      width: 100%;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "from": "С",
    "to": "Дo",
    "show-track": "Показать трек",
    "hide-track": "Скрыть трек",
    "sc:track-period": "Выберите временной период",

    "request:null:title": "Уведомление",
    "request:null:message": "Данные для отображения трека отсутствуют"
  },
  "en": {
    "from": "From",
    "to": "To",
    "create-track": "Show track",
    "Hide-track": "Hide track",
    "sc:track-period": "Choose time period",

    "request:null:title": "Error",
    "request:null:message": "No data to display the track"
  }
}
</i18n>
